/*
* Global rich text styling when not passed into the RichTextWrapper
*/
export default class RichTextStyling { };

RichTextStyling.DEFAULT = {
    b: { font: "bold 40px 'Roboto'" },
    i: { font: "italic 40px 'Roboto'" },
    bi: { font: "bold italic 40px 'Roboto'" },
    a: {
        font: "40px 'Roboto'",
        hover: {
            color: "#1F40E6"
        }
    },
    _default: { // _default, because 'default' is a reserved keyword
        font: "40px 'Roboto'"
    }
}

RichTextStyling.defaultForFont = function (font) {
    return {
        b: { font: "bold " + font },
        i: { font: "italic " + font },
        bi: { font: "bold italic " + font },
        a: {
            font: font,
            color: "#FFF",
            hover: {
                color: "#888"
            }
        },
        _default: {
            font: font
        }
    };
}

RichTextStyling.whiteColorForFont = function (fontName) {
    return {
        b: { font: "bold " + fontName },
        i: { font: "italic " + fontName },
        bi: { font: "bold italic " + fontName },
        a: {
            font: fontName,
            color: "#FFF",
            hover: {
                color: "#FFF"
            }
        },
        _default: {
            font: fontName
        }
    };
}